import { Button } from 'antd'
import { isNil, toInteger } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { RoleCode } from '@eastcoal/shared/enums/RoleCode'

import { AbortiveExplainStatus } from '../../../enums/AbortiveExplainStatus'
import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AbortiveExplainDetailButtonProps } from './interface'

export const AbortiveExplainDetailButton = ({
  record
}: AbortiveExplainDetailButtonProps) => {
  const roles = useAuthStore(state => state.roles)
  const hasPermission = roles.some(
    role =>
      role.code === RoleCode.SUPERADMIN ||
      role.code === RoleCode.CUSTMANAGER ||
      role.code === RoleCode.KINDMANAGER
  )
  const { setCurrentAuction, toggleAbortiveExplainVisible } =
    useAuctionListStore(state =>
      pick(state, ['setCurrentAuction', 'toggleAbortiveExplainVisible'])
    )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleAbortiveExplainVisible(true)
  }

  return hasPermission &&
    !isNil(record.explainStatus) &&
    AbortiveExplainStatus.SIGNING_SUCCESS !== toInteger(record.explainStatus) &&
    AuctionOperationPageStatus.DEAL_FAIL === toInteger(record.status) ? (
    <Button type='link' onClick={handleClick}>
      查看说明
    </Button>
  ) : null
}
